<template>
    <div class="animated fadeIn">
        <b-row :class="isDocument">
            <b-col lg="12">
                <b-card class="mt-0">
                    <b-tabs content-class="mt-0" v-model="tabIndex">
                        <b-tab title="Xem chi tiết khai thác tài sản" active>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Đơn vị quản lý: "
                                                  :label-cols="4"
                                                  label-class="label-bold"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <b-form-input :value="assetExploitationDecision.unitName" :title="assetExploitationDecision.unitName" :readonly="true"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Hình thức khai thác:"
                                                  :label-cols="4"
                                                  label-class="label-bold"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <b-form-input :value="assetExploitationDecision.exploitationTypeName" :title="assetExploitationDecision.exploitationTypeName" :readonly="true"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="QĐ phê duyệt Đề án số:"
                                                  :label-cols="4"
                                                  label-class="label-bold"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <b-form-input :value="assetExploitationDecision.decisionNumber" :title="assetExploitationDecision.decisionNumber" :readonly="true"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="3">
                                    <b-form-group label="ngày:"
                                                  :label-cols="4"
                                                  label-class="label-bold"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <b-form-input :value="assetExploitationDecision.decisionDate | formatDate" :title="assetExploitationDecision.decisionDate | formatDate" :readonly="true"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="3">
                                    <b-form-group label="của:"
                                                  :label-cols="4"
                                                  label-class="label-bold"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <b-form-input :value="assetExploitationDecision.approver" :title="assetExploitationDecision.approver" :readonly="true"></b-form-input>
                                    </b-form-group>
                                </b-col>


                                <template v-if="assetExploitationDecision.exploitationType == 2 || assetExploitationDecision.exploitationType == 4">
                                    <b-col md="6">
                                        <b-form-group label="Ngày khai thác từ ngày: "
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="assetExploitationDecision.startDate | formatDate" :title="assetExploitationDecision.startDate | formatDate" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Đến ngày: "
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="assetExploitationDecision.endDate | formatDate" :title="assetExploitationDecision.endDate | formatDate" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </template>


                                <template v-if="assetExploitationDecision.exploitationType == 4">
                                    <b-col md="6">
                                        <b-form-group label="Số hợp đồng: "
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="assetExploitationDecision.contractNumber" :title="assetExploitationDecision.contractNumber" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Ngày hợp đồng: "
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="assetExploitationDecision.contractDate | formatDate" :title="assetExploitationDecision.contractDate | formatDate" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </template>


                                <b-col md="6">
                                    <b-form-group label="Số thu dự kiến theo Đề án được duyệt: "
                                                  :label-cols="4"
                                                  label-class="label-bold"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <b-form-input :value="assetExploitationDecision.expectedValue | currency" :title="assetExploitationDecision.expectedValue | currency" :readonly="true"></b-form-input>
                                    </b-form-group>
                                </b-col>

                                <b-col md="6">
                                    <b-form-group label="Số tiền đã thu được cộng dồn:"
                                                  :label-cols="4"
                                                  label-class="label-bold"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <b-form-input :value="assetExploitationDecision.obtainedValue | currency" :title="assetExploitationDecision.obtainedValue | currency" :readonly="true"></b-form-input>
                                    </b-form-group>
                                </b-col>

                                <b-col md="6">
                                    <b-form-group label="Nội dung:"
                                                  title="Mã tài sản tại kho do kho cấp (tự động sinh)"
                                                  :label-cols="4"
                                                  label-class="label-bold"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <b-form-input :value="assetExploitationDecision.contractContent" :title="assetExploitationDecision.contractContent" :readonly="true"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6" v-if="assetExploitationDecision.exploitationType == 4">
                                    <b-form-group label="Đối tác: "
                                                  :label-cols="4"
                                                  label-class="label-bold"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <b-form-input :value="assetExploitationDecision.partnerName" :title="assetExploitationDecision.partnerName" :readonly="true"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Ghi chú:"
                                                  :label-cols="4"
                                                  label-class="label-bold"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <b-form-input :value="assetExploitationDecision.notes" :title="assetExploitationDecision.notes" :readonly="true"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <br />
                            <b-grid :gridOptions="gridOptions"
                                    :items="assetExploitationDecision.exploitingAssets"
                                    :showActions="true"
                                    ref="assetDepreciationTable"
                                    gridName="Danh sách tài sản khai thác">
                                <template v-slot:cell(assetCode)="row">
                                    <router-link v-if="authorize(['QLTSC_ViewAsset', 'CTNS_ViewAsset', 'HTGTDB_ViewAsset'])" :to="{ path: `/data/organization-assets/${row.item.assetId}` }">
                                        {{ row.value }}
                                    </router-link>
                                    <label class="control-label" v-if="!authorize(['QLTSC_ViewAsset', 'CTNS_ViewAsset', 'HTGTDB_ViewAsset'])">{{ row.value }}</label>
                                </template>
                                <template v-slot:cell(exploitingArea)="row">
                                    {{ row.value | formatNumber }}
                                </template>
                                <template v-slot:cell(area)="row">
                                    {{ row.value | formatNumber }}
                                </template>
                                <template v-slot:cell(expectedValue)="row">
                                    {{ row.value | currency }}
                                </template>
                                <template v-slot:cell(obtainedValue)="row">
                                    {{ row.value | currency }}
                                </template>
                                <template v-slot:cell(_actions)="row">
                                    <b-button-group>
                                        <b-button v-if="authorize(['ViewAssetExploitationDecision'])"
                                                  size="sm" title="xem" variant="info"
                                                  v-b-modal.exploitingAssetInfoModal @click="showExploitingAssetDetail(row.item, row.index, $event.target)">
                                            Xem
                                        </b-button>
                                    </b-button-group>
                                </template>
                            </b-grid>
                        </b-tab>
                        <b-tab title="Cập nhật số tiền khai thác tài sản" class="mt-3">
                            <b-form @submit.prevent="search">
                                <!--<b-row>
                                    <b-col offset-md="2">
                                        <b-form-group label="Số chứng từ:"
                                                      label-for="input-string"
                                                      label-cols-md="3"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input id="input-string" class="col-md-6"
                                                          v-model="searchForm.documentNumber"
                                                          type="text"
                                                          placeholder="Nhập số chứng từ">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>-->
                                <b-row>
                                    <b-col offset-md="2">
                                        <b-form-group label="Ngày khai thác - từ ngày:"
                                                      label-for="input-string"
                                                      label-cols-md="3"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <date-picker v-model="searchForm.startDate" class="col-md-6" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col offset-md="2">
                                        <b-form-group label="Đến ngày:"
                                                      label-for="input-string"
                                                      label-cols-md="3"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <date-picker v-model="searchForm.endDate" class="col-md-6" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col offset-md="2">
                                        <b-form-group label="" :label-cols="4" label-cols-md="3">
                                            <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-form>
                            <br />
                            <!--:items="assetExploitationDecision.documents" dataUrl="data/asset-exploitation-documents"-->
                            <b-grid :gridOptions="documentGridOptions"
                                    v-if="searchForm.decisionId"
                                    dataUrl="data/asset-exploitation-documents"
                                    :searchForm="searchForm"
                                    ref="assetExploitationDocumentTable"
                                    gridName="Danh sách số tiền khai thác">
                                <!--<template v-slot:actions>
                                    <b-button size="md" @click.stop="removeSelectedExploitationDocument" variant="danger" :disabled="isShowBtnDelete" v-if="authorize(['ManageAssetExploitationDocument'])">
                                        Xóa
                                    </b-button>
                                </template>-->
                                <template v-slot:cell(documentDate)="row">
                                    {{ row.value | formatDate }}
                                </template>
                                <template v-slot:cell(obtainedValue)="row">
                                    {{ row.value | currency }}
                                </template>
                                <template v-slot:cell(_actions)="row">
                                    <b-button-group>
                                        <b-button v-if="authorize(['ViewAssetExploitationDocument'])"
                                                  @click="showDocumentAssetDetail(row.item, row.index, $event.target)"
                                                  size="sm" title="xem" variant="info">
                                            Xem
                                        </b-button>
                                        <b-button v-if="authorize(['ManageAssetExploitationDocument'])" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                            Xoá
                                        </b-button>
                                    </b-button-group>
                                </template>
                            </b-grid>
                        </b-tab>
                    </b-tabs>
                </b-card>
                <b-card style="margin-top: 0; padding-top: 0">
                    <b-row>
                        <b-col class="text-center">
                            <div class="form-group">
                                <b-button type="button" :to="{ path: '/data/organization-assets/asset-exploitation-decisions/list' }">Quay lại</b-button>
                                <!--<b-button type="button" :to="{ path: `/data/asset-mutations/list?assetCode=${assetExploitationDecision.code}&unitOption=2` }">Danh sách biến động</b-button>-->
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <!-- Info modal -->
        <b-modal :no-enforce-focus="true" :id="infoModal.id" :title="infoModal.title" size="lg">
            <b-row class="document-view">
                <b-col offset-md="2">
                    <b-form-group label="Ngày khai thác: "
                                  label-cols-md="3"
                                  label-class="label-bold"
                                  :horizontal="true"
                                  label-align="left">
                        <b-form-input class="col-md-6" :value="documentAsset.documentDate | formatDate" :title="documentAsset.documentDate | formatDate" :readonly="true"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="document-view">
                <b-col offset-md="2">
                    <b-form-group label="Số tiền thu được: "
                                  label-cols-md="3"
                                  label-class="label-bold"
                                  :horizontal="true"
                                  label-align="left">
                        <b-form-input class="col-md-6" :value="documentAsset.obtainedValue | currency" :title="documentAsset.obtainedValue | currency" :readonly="true"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="document-view">
                <b-col offset-md="2">
                    <b-form-group label="Nội dung: "
                                  label-cols-md="3"
                                  label-class="label-bold"
                                  :horizontal="true"
                                  label-align="left">
                        <b-form-input class="col-md-6" :value="documentAsset.notes" :title="documentAsset.notes" :readonly="true"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <!--<template v-if="documentAsset.exploitingAssets && documentAsset.exploitingAssets.length > 0">
                <b-grid :gridOptions="documentAssetGridOptions"
                        :items="documentAsset.exploitingAssets"
                        :searchForm="searchForm"
                        ref="assetExploitationDocumentAssetTable"
                        :showActions="false"
                        gridName="Danh sách tài sản khai thác">
                    <template v-slot:cell(exploitingArea)="row">
                        {{ row.value | formatNumber }}
                    </template>
                    <template v-slot:cell(area)="row">
                        {{ row.value | formatNumber }}
                    </template>
                    <template v-slot:cell(obtainedValue)="row">
                        {{ row.value | currency }}
                    </template>
                </b-grid>
            </template>-->
            <template #modal-footer="{ ok, cancel, hide }">
                <b-button style="margin:auto" variant="secondary" @click="cancel()">
                    Đóng
                </b-button>
            </template>
        </b-modal>

        <b-modal :no-enforce-focus="true" id="exploitingAssetInfoModal"
                 size="lg"
                 title="Thông tin khai thác tài sản">
            <b-row class="document-view">
                <!--Thông tin chung-->
                <b-col md="6">
                    <b-form-group label="Mã tài sản tại kho: "
                                  label-cols-md="4"
                                  label-class="label-bold"
                                  :horizontal="true"
                                  label-align="left">
                        <b-form-input :value="exploitingAssetDetail.assetCode" :title="exploitingAssetDetail.assetCode" :readonly="true"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Tên tài sản: "
                                  label-cols-md="4"
                                  label-class="label-bold"
                                  :horizontal="true"
                                  label-align="left">
                        <b-form-input :value="exploitingAssetDetail.assetName"
                                      :title="exploitingAssetDetail.assetName"
                                      :readonly="true"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Mã tài sản tại đơn vị: "
                                  label-cols-md="4"
                                  label-class="label-bold"
                                  :horizontal="true"
                                  label-align="left">
                        <b-form-input :value="exploitingAssetDetail.assetSyncSourceId" :title="exploitingAssetDetail.assetSyncSourceId" :readonly="true"></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Loại tài sản: "
                                  label-cols-md="4"
                                  label-class="label-bold"
                                  :horizontal="true"
                                  label-align="left">
                        <b-form-input :value="exploitingAssetDetail.assetTypeName"
                                      :title="exploitingAssetDetail.assetTypeName"
                                      :readonly="true"></b-form-input>
                    </b-form-group>
                </b-col>



                <!--Khai thác là Cho thuê-->
                <template v-if="assetExploitationDecision.exploitationType == 1">
                    <b-col md="6">
                        <b-form-group label="Phương thức cho thuê: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="getLeaseMethod(exploitingAssetDetail.leaseMethod)"
                                          :title="getLeaseMethod(exploitingAssetDetail.leaseMethod)"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Đơn vị thuê: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.partnerName"
                                          :title="exploitingAssetDetail.partnerName"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Số hợp đồng cho thuê: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.contractNumber"
                                          :title="exploitingAssetDetail.contractNumber"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Ngày hợp đồng cho thuê: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.contractDate | formatDate"
                                          :title="exploitingAssetDetail.contractDate | formatDate"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Thời hạn cho thuê từ ngày: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.startDate | formatDate"
                                          :title="exploitingAssetDetail.startDate | formatDate"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Đến ngày: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.endDate | formatDate"
                                          :title="exploitingAssetDetail.endDate | formatDate"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group label="Đơn giá cho thuê: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.leasePrice | currency"
                                          :title="exploitingAssetDetail.leasePrice | currency"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                </template>

                <!--Khai thác là Liên doanh, liên kết-->
                <template v-if="assetExploitationDecision.exploitationType == 3">
                    <b-col md="6">
                        <b-form-group label="Phương thức LDLK: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="getVentureForms(exploitingAssetDetail.ventureForm)"
                                          :title="getVentureForms(exploitingAssetDetail.ventureForm)"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Tên pháp nhân mới: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.newLegalEntityName"
                                          :title="exploitingAssetDetail.newLegalEntityName"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Số hợp đồng: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.contractNumber"
                                          :title="exploitingAssetDetail.contractNumber"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Ngày hợp đồng: "
                                      :label-cols="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.contractDate | formatDate" :title="exploitingAssetDetail.contractDate | formatDate" :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group label="LDLK từ ngày: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.startDate | formatDate"
                                          :title="exploitingAssetDetail.startDate | formatDate"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Đến ngày: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.endDate | formatDate"
                                          :title="exploitingAssetDetail.endDate | formatDate"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Đối tác thực hiện LDLK: "
                                      label-cols-md="4"
                                      label-class="label-bold"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="exploitingAssetDetail.partnerName"
                                          :title="exploitingAssetDetail.partnerName"
                                          :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>

                </template>

                <!--Khai thác là kinh doanh hoặc khác  v-if="assetExploitationDecision.exploitationType == 2 || assetExploitationDecision.exploitationType == 4"-->
                <b-col md="6">
                    <b-form-group label="Diện tích: "
                                  label-cols-md="4"
                                  label-class="label-bold"
                                  :horizontal="true"
                                  label-align="left">
                        <b-form-input :value="exploitingAssetDetail.area | formatNumber"
                                      :title="exploitingAssetDetail.area | formatNumber"
                                      :readonly="true"></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Diện tích khai thác: "
                                  label-cols-md="4"
                                  label-class="label-bold"
                                  :horizontal="true"
                                  label-align="left">
                        <b-form-input :value="exploitingAssetDetail.exploitingArea | formatNumber"
                                      :title="exploitingAssetDetail.exploitingArea | formatNumber"
                                      :readonly="true"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <template #modal-footer="{ ok, cancel, hide }">
                <b-button style="margin:auto" variant="secondary" @click="cancel()">
                    Đóng
                </b-button>
            </template>
        </b-modal>
    </div>

</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'AssetExploitationDecisionDetail',
        mixins: [mixins],
        components: {
        },
        data() {
            return {
                assetExploitationDecision: {
                    unitName: null,
                },
                gridOptions: {
                    fields: [
                        { key: 'assetCode', label: 'Mã tài sản tại kho', sortable: true },
                        { key: 'assetSyncSourceId', label: 'Mã tài sản tại đơn vị', sortable: true },
                        { key: 'assetName', label: 'Tên tài sản', sortable: true },
                        { key: 'assetTypeName', label: 'Loại tài sản', sortable: true },
                        { key: 'area', label: 'Diện tích', sortable: true, tdClass: 'text-right' },
                        { key: 'exploitingArea', label: 'Diện tích khai thác', sortable: true, tdClass: 'text-right' },
                        //{ key: 'expectedValue', label: 'Số tiền thu được dự kiến', sortable: true, tdClass: 'text-right'},
                        //{ key: 'obtainedValue', label: 'Tổng số tiền thu được', sortable: true, tdClass: 'text-right' },
                    ]
                },
                documentGridOptions: {
                    fields: [
                        { key: 'documentDate', label: 'Ngày khai thác', sortable: true },
                        //{ key: 'documentNumber', label: 'Số chứng từ', sortable: true },
                        { key: 'obtainedValue', label: 'Số tiền thu được', sortable: true, tdClass: 'text-right' },
                        { key: 'notes', label: 'Nội dung', sortable: false },
                    ]
                },
                documentAssetGridOptions: {
                    fields: [
                        { key: 'assetCode', label: 'Mã tài sản', sortable: true },
                        { key: 'assetName', label: 'Tên tài sản', sortable: true },
                        { key: 'assetTypeName', label: 'Loại tài sản', sortable: true },
                        { key: 'exploitingArea', label: 'Diện tích khai thác', sortable: true, tdClass: 'text-right' },
                        { key: 'area', label: 'Diện tích', sortable: true, tdClass: 'text-right' },
                        { key: 'obtainedValue', label: 'Số tiền thu được', sortable: true, tdClass: 'text-right' },
                    ]
                },
                searchForm: {
                    documentNumber: null,
                    startDate: null,
                    endDate: new Date().formatDate(),
                    decisionId: '',
                },
                tabIndex: null,
                isDocument: 'document-view',
                assetExploitationDocuments: [],
                isShowBtnDelete: true,
                infoModal: {
                    id: 'detail-document-asset-modal',
                    title: '',
                    content: ''
                },
                documentAsset: {},
                documentId: '',
                dataUrlDocumentAsset: 'a',
                documentAssets: [],
                exploitingAssetDetail: {
                    assetCode: null,
                    assetSyncSourceId: null,
                    assetName: null,
                    assetTypeName: null,
                    area: null,
                    exploitingArea: null,
                    leaseMethod: null,
                    contractNumber: null,
                    contractDate: null,
                    startDate: null,
                    endDate: null,
                    partnerName: null,
                    leasePrice: null,
                    // LDLK
                    ventureForm: null,
                    newLegalEntityName: null,
                },
                ventureForms: [
                    { id: 1, text: 'Tự quản lý' },
                    { id: 2, text: 'Đồng kiểm soát' },
                    { id: 3, text: 'Thành lập pháp nhân mới' },
                ],
                leaseMethods: [
                    { id: 1, text: 'Đấu giá' },
                    { id: 2, text: 'Trực tiếp' }
                ]
            }
        },
        mounted() {
            var vm = this;
            vm.$watch(
                () => {
                    return this.searchForm.decisionId && vm.$refs.assetExploitationDocumentTable.selectedRows
                },
                (val) => {
                    vm.isShowBtnDelete = val.length == 0;
                }
            )

            if (vm.assetExploitationDecisionId) {
                vm.searchForm.decisionId = vm.assetExploitationDecisionId;
            }
        },
        computed: {
            assetExploitationDecisionId() {
                return this.$route.params.assetExploitationDecisionId;
            },
        },
        created() {
            this.loadAssetExploitationDecisionDetail();
        },
        methods: {
            loadAssetExploitationDecisionDetail() {
                var vm = this;
                if (this.assetExploitationDecisionId) {
                    return this.$services.get(`data/asset-exploitation-decisions/${this.assetExploitationDecisionId}`).done(data => {
                        vm.assetExploitationDecision = data;
                    });
                }
            },
            search() {
                this.$refs.assetExploitationDocumentTable.refresh();
            },
            showDocumentAssetDetail(item, index, button) {
                //this.dataUrlDocumentAsset = `data/asset-exploitation-documents/${item.id}/assets`
                //this.loadAssetExploitationDocumentAsssets(item.id);
                this.documentAsset = item;
                this.infoModal.title = `Xem thông tin chi tiết của số tiền khai thác`;
                this.infoModal.content = item.errorMessage;
                this.$root.$emit('bv::show::modal', this.infoModal.id, button);
            },
            loadAssetExploitationDocumentAsssets(documentId) {
                var vm = this;
                return this.$services.get(`data/asset-exploitation-documents/${documentId}/assets`).done(data => {
                    vm.documentAssets = data.data;
                });
            },
            removeSelectedExploitationDocument() {
                var vm = this;
                var selectedRows = this.$refs.assetExploitationDocumentTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các số tiền khai thác này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/asset-exploitation-documents?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các số tiền khai thác thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn số tiền khai thác cần xóa');
                }
            },
            showExploitingAssetDetail(item, index, button) {
                // Reset data của popup về null
                this.exploitingAssetDetail = {
                    assetCode: null,
                    assetSyncSourceId: null,
                    assetName: null,
                    assetTypeName: null,
                    area: null,
                    exploitingArea: null,
                    leaseMethod: null,
                    contractNumber: null,
                    contractDate: null,
                    startDate: null,
                    endDate: null,
                    partnerName: null,
                    leasePrice: null,
                    // LDLK
                    ventureForm: null,
                    newLegalEntityName: null,
                };

                //var assetExploitationDecision = this.assetExploitationDecision;
                this.exploitingAssetDetail = {
                    ...item,
                    //leaseMethod: assetExploitationDecision.leaseMethod,
                    //contractNumber: assetExploitationDecision.contractNumber,
                    //contractDate: assetExploitationDecision.contractDate,
                    //startDate: assetExploitationDecision.startDate,
                    //endDate: assetExploitationDecision.endDate,
                    //partnerName: assetExploitationDecision.partnerName,
                    //leasePrice: assetExploitationDecision.leasePrice,
                    //ventureForm: assetExploitationDecision.ventureForm,
                    //newLegalEntityName: assetExploitationDecision.newLegalEntityName,
                };
            },
            getLeaseMethod(id) {
                var item = this.leaseMethods.find(x => x.id == id);
                return item ? item.text : "";
            },
            getVentureForms(id) {
                var item = this.ventureForms.find(x => x.id == id);
                return item ? item.text : "";
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa số tiền khai thác này?')) {
                    this.$services.delete(`data/asset-exploitation-documents/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa số tiền khai thác thành công');
                        vm.search();
                    });
                }
            },
        },
        watch: {
            tabIndex(val) {
                if (val != 0) {
                    this.isDocument = '';
                }
                else {
                    this.isDocument = 'document-view';
                }
            }
        }
    }
</script>
<style scoped>

    label {
        font-weight: 400;
        font-style: italic;
    }

    .text-1 {
        font-weight: 500;
    }

    .card {
        margin-bottom: 0;
        margin-top: 1rem;
        border: none;
    }

    /* .remove-document-view input {
        margin-top: 30px;
        background-color: none !important;
        border-top: 1px !important;
        border-left: 1px !important;
        border-right: 1px !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        resize: none;
        overflow: hidden;
        color: #000;
        border-radius: 1px;
    }*/
</style>
